import { Map } from '../map/map';
import { Copromote } from '../copromote/copromote';
import { Description } from '../event/description';
import { BuyTicketsWidget } from '../modals/tickets'
import { HashHandler } from '../hash_handler';
import { ModalTemplate } from '../modals/template';
import { NewEventModal } from '../modals/new_event';

require('jquery-jeditable');
/**
 * Event
 */
class Event {
    constructor(eventId, userId, isNewEvent,settings) {
        this.locked = false;

        this.eventId = eventId;
        this.userId = userId;
        this.isNewEvent = isNewEvent;

        this.rsvpStatus = typeof settings.rsvp == 'undefined' ? 1 : settings.rsvp;
        this.texts = settings.texts;

        this.lat = settings.lat;
        this.lng = settings.lng;

        this.perms = settings.perms;

        this.future = settings.future;

        new Map(this);
        new Copromote(this);

        this.initEditables();
        this.initPeopleRSVPWidget();

        var that = this;

        $("#imageupload").change(function(e) {
            $("#pictureForm").submit();
        });

        that._initUrlImagePreview();

        // hash handler
        this.hashHandler = new HashHandler();

        this.hashHandler.addAction('#discussions-box', false, function() {
            $('a[href="#discussions-box"]').click();
        });

        this.hashHandler.addAction('#share', false, function() {
            profile.shareEvent(that.eventId);
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#rsvp', true, function(status) {
            that.rsvp(parseInt(status));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#accept-invite', true, function(inviteId) {
            that.acceptInvite(parseInt(inviteId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#decline-invite', true, function(inviteId) {
            that.declineInvite(parseInt(inviteId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#accept-request', true, function(requestId) {
            that.acceptRequest(parseInt(requestId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#decline-request', true, function(requestId) {
            that.declineRequest(parseInt(requestId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

this.hashHandler.addAction('#buy-tickets', false, function() {
    if(that.buyTicketsWidget) {
        that.buyTicketsWidget.button.click();
    }
});

this.hashHandler.addAction('#buy-tickets-finish', true, function(orderId) {
    profile.buyTickets(that.eventId, null, { finishOrderId: orderId });
    that.hashHandler.clearHash();
});

        if(this.isNewEvent){
            this.newEventModalShow();
        }
        // refresh
        setTimeout(function() {
            that._refresh();
        }, 30000);
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    _refresh() {
        var that = this;
        if (isNaN(parseInt(that.userId)) || !parseInt(that.userId))
            return false;
        that.loadComments($('#discussions-box div.paging a.active').html());

        setTimeout(function() {
            that._refresh();
        }, 30000);
    }

    _initUrlImagePreview() {
        $('#event_description a[href], #discussions-box a[href], #reviews-box a[href]')
            .on('mouseover', 'a', function(e) {
                if (!/(jpg|gif|png)$/.test($(this).attr('href'))) {
                    return false;
                }
                else {
                    var containerOffset = Math.ceil(($(document).width() - 980) * 0.5);
                    var imageBox = null;
                    var offsetLeft = 0;
                    var that = $(this);

                    $('body').append(
                        '<div id="url-image-preview">' +
                            '<img alt="" id="url-image-preview-image" src="'+ $(this).attr('href') +'" />' +
                        '</div>'
                    );

                    imageBox = $('#url-image-preview');

                    $('#url-image-preview-image').load(function() {
                        imageBox.css({
                            marginTop: imageBox.height() * -0.5,
                            opacity: 1.0,
                            top: that.offset().top + 3
                        });

                        offsetLeft = that.offset().left + that.width() + 15;

                        if(offsetLeft + imageBox.width() + 10 >= containerOffset + 760 && that.width() <= 250) {
                            imageBox.addClass('position-left').css({
                                right: $(document).width() - that.offset().left + 15
                            });
                        }
                        else {
                            imageBox.addClass('position-right').css({
                                left: offsetLeft
                            });
                        }
                    });
                }})
            .on('mouseout', 'a', function () { $("#url-image-preview").remove();})
            .on('click', 'a', function () { $("#url-image-preview").remove();});
    }

    rsvp(status) {
        if(this.locked) return;
        var that = this;

        profile.rsvp(this.eventId, status, true, () => {
            $("#event .rsvp-marker").each((k, v) => {
                $(v).addClass("disabled");
            });

            $("#event .rsvp-marker.rsvp-" + status).removeClass("disabled");
        })
    }

    rate(rating, review) {
        if (!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return;
        }
        if (this.locked) return;

        var that = this;
        this._lock();

        if($("#event-rating-overlay").parent().attr('rel') == 'tooltip') {
            $("#event-rating-overlay").parent()
            .tooltip('hide')
            .attr('data-original-title', that.texts.thanksForVoting)
            .tooltip('fixTitle');
            if (!review)
                $("#event-rating-overlay").parent().tooltip('show');
        }
        else {
            $("#event-rating-overlay").parent()
            .attr('rel', 'tooltip')
            .attr('title', that.texts.thanksForVoting)
            .tooltip({ animation: false });
            if (!review)
                $("#event-rating-overlay").parent().tooltip('show');
        }

        $("#event-rating-overlay").parent()
            .attr('data-original-title', that.texts.voted.replace(/%d/, rating))
            .tooltip('fixTitle');

        $("#event-rating-overlay").css('width', Math.round((rating / 5) * 100) + '%');

        if (!review) {
            $.ajax({
                url: "/event/rate/", dataType: 'json', type: 'post',
                data: {id: this.eventId, rating: rating},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        $("#event-rating-overlay").css('width', data.ratingPercentage + '%');

                        that._unlock();
                    } else {
                        that._unlock();
                    }
                }
            });
        }
    }

    comment(msg) {
        if (!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return;
        }
        if (this.locked) return;

        var that = this;
        this._lock();

        // $.ajax({
        //     url: "/event/comment/", dataType: 'json', type: 'post',
        //     data: {id: this.eventId, text: msg},
        //     success: function(data) {
        //         if (data && data.success != undefined && data.success) {
        //             $("#discussions-box .item, #discussions-box .paging").remove();
        //             $("#discussions-box").prepend(data.comments);
        //             $("#discussions-box textarea[name='message']").val('');
        //             $("#comments-count").html(data.commentsCount);
        //             $("#discussions-box .no-items").remove();

        //             that._unlock();
        //             $.ajax({
        //                 url: "/event/comment-facebook/", dataType: 'json', type: 'post',
        //                 data: {id: that.eventId},
        //                 success: function(data) {

        //                 }
        //             });
        //             $.ajax({
        //                 url: "/event/comment-twitter/", dataType: 'json', type: 'post',
        //                 data: {id: that.eventId},
        //                 success: function(data) {

        //                 }
        //             });
        //         } else {
        //             that._unlock();
        //         }
        //     }
        // });
    }

    loadComments(on_page) {
        if (this.locked) return;

        var that = this;
        this._lock();

        // $.ajax({
        //     url: "/event/comments/", dataType: 'json', type: 'post',
        //     data: {id: this.eventId, page: on_page},
        //     success: function(data) {
        //         if (data && data.success != undefined && data.success) {
        //             $("#discussions-box .item, #discussions-box .paging").remove();

        //             if (data.commentsCount > 0) {
        //                 $("#discussions-box div.no-items").remove();
        //                 $("#comments-count").html(data.commentsCount);
        //                 $("#discussions-box").prepend(data.comments);
        //             }

        //             that._unlock();
        //         } else {
        //             that._unlock();
        //         }
        //     }
        // });
    }

    cancelEvent() {
        var that = this;

        if(!window.confirm(that.texts.deleteEvent)) {
            return;
        }

        $.ajax({
            url: '/event/cancel/',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId
            },
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    window.location = '/';
                }
            }
        });
    }

    show() {
        var that = this;

        // debugger;
        // initTabs();

        // linked events
        var linkedEventsBox = $('div.linked-events');

        if(linkedEventsBox.length) {
            var linkedEventsListId = linkedEventsBox.data('id');
            var linkedEventsPaging = $('nav.paging a', linkedEventsBox);

            $('a.expand', linkedEventsBox).click(function() {
                linkedEventsBox.addClass('transition').toggleClass('expanded');

                if(linkedEventsBox.hasClass('expanded')) {
                    $.cookie('linked_list_' + linkedEventsListId + '_opened', true, { expires: 1, path: '/' });
                }
                else {
                    $.removeCookie('linked_list_' + linkedEventsListId + '_opened', { path: '/' });
                }

                return false;
            });

            if(linkedEventsPaging.length) {
                linkedEventsPaging.click(function() {
                    linkedEventsPaging.removeClass('active');
                    $(this).addClass('active');

                    $('div.mask', linkedEventsBox).animate(
                        { scrollLeft: $(this).index() * 620 },
                        { duration: 500, queue: false }
                    );

                    return false;
                });
            }
        }

        // rating
        $('div.event').find('div.rating').find('a').each(function() {
            $(this)
            .mouseover(function() { $(this).parent().addClass('no-background'); })
            .mouseout(function() { $(this).parent().removeClass('no-background'); });
        });

        // actions
        if($('section.summary').hasClass('vertical')) {
            var imageWidth = $('div.image img', 'section.summary').width();

            $('section.summary').find('div.information').width(730 - imageWidth);
            $('section.summary').find('div.social').css('marginLeft', Math.floor((730 - imageWidth - 40 - 245) * 0.5) + 2);
        }

        // description
        this.description = new Description();

        // cohosts

        if(window.evedo.isLogged()) {
            var cohostsInput = $('input[name="cohost"]');
            var copromoteRequestWidget = $('#copromote-request-widget');

            if (cohostsInput.length) {
                cohostsInput.autocomplete({
                    autoFocus: true,
                    source: function( request, response ) {
                        $.ajax({
                            url: "/common/token-hosts/",
                            dataType: "json",
                            minChars: 2,
                            data: {
                                q: $('input[name="cohost"]').val()
                            },
                            success: function( data ) {
                                response( $.map( data, function( item ) {
                                    return {
                                        label: item.name,
                                        value: item.name,
                                        id: item.id,
                                        image: item.image
                                    }
                                }));
                            }
                        });
                    },
                    change: function(event, ui) {
                        if(ui.item !== null && ui.item.id !== null)
                            $("#cohost-hidden").val(ui.item.id);
                        else
                            $("#cohost-hidden").val('');
                    },
                    select: function(event, ui) {
                        $("#cohost-hidden").val(ui.item.id);
                        that.addCohost();
                    }
                });

                cohostsInput.data('ui-autocomplete')._renderItem = function(ul, item) {
                    return $('<li class="autocomplete-image-item"></li>')
                        .data('item.autocomplete', item)
                        .append('<a href="#"><img src="' + item.image + '">' + item.label + '</a>')
                        .appendTo(ul);
                }
            }

            if (copromoteRequestWidget.length) {
                new CopromoteRequestWidget(copromoteRequestWidget, this.eventId);
            }
        }

        // buy tickets widget
        this.buyTicketsWidget = $('.sidebar-widget#buy-tickets-widget');

        if(this.buyTicketsWidget.length) {
            this.buyTicketsWidget = new BuyTicketsWidget(this.buyTicketsWidget, this.eventId, {
                texts: that.texts.buyTicketsWidget
            });
        }
        else {
            this.buyTicketsWidget = null;
        }
    }

    initPeopleRSVPWidget() {
        var peopleRSVPWidget = $('.people-rsvp-widget');

        if (peopleRSVPWidget.length) {
            peopleRSVPWidget.find('div > a').on('click', function() {
                $.ajax({
                    url: "/event/invitees-widget/",
                    dataType: 'json',
                    type: 'post',
                    data: {
                        id: $('div.event').data('event'),
                        page: $(this).data('page')
                    },
                    success: function(data) {
                        if (data) {
                            peopleRSVPWidget.html(data);
                        }
                    }
                });
            });
        }
    }

    initEditables() {
        var that = this;

        if (!that.perms.mainInfo || !that.future)
            return;

        // name
        $('.editable-name').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable name',
            type        : 'text',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            onsubmit    : function (settings, original) {
                if (original.revert == $('input',this).val() || $.trim($('input',this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            }
        });

        // short-description
        $('.editable-short-description').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable short-description',
            type        : 'text',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            onsubmit    : function (settings, original) {
                if (original.revert == $('input',this).val()) {
                    original.reset();
                    return false;
                }
            }
        });

        // description
        $('.editable-description').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable description',
            type        : 'textarea',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            data        : function (original, settings) {
                original = $('<div>' + original + '</div>');

                $('a', original).each(function (key, el) {
                    $(el).text($(el).attr('href'));
                });

                return original.text();
            },

            onedit      : function (settings, original) {
                $("#url-image-preview").remove();
                that.description.reset(true);
            },

            onsubmit    : function (settings, original) {
                if (original.revert == $('textarea', this).val() || $.trim($('textarea', this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            },

            callback    : function(value, settings) {
                that.description.reset();
                that.description.expand(true);
            }
        });
    }

    featureEvent() {
        profile.featureEvent(this.eventId, function(data) {
            var campaignsPanel = $('.round-buttons.featured-campaigns');

            if(data.success) {
                window.setTimeout(function() {
                    campaignsPanel.addClass('available bounce');
                }, 250);

                window.setTimeout(function() {
                    campaignsPanel.removeClass('bounce');
                }, 750);
            }
        });
    }

    featuredReport() {
        profile.featuredEventReport(this.eventId);
    }

    openBillingInformation() {
        profile.openBillingInformation(this.eventId);
    }

    embedTickets() {
        profile.embedTickets(this.eventId);
    }

    manageDiscountCodes() {
        profile.manageDiscountCodes(this.eventId);
    }

    newEventModalShow(callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.newEventModal) {
            this.newEventModal = new ModalTemplate('new-event-modal', { keyboard: false });
        }

        window.activeModalInstance = new NewEventModal(this.newEventModal, this.eventId, callback);
    }

    featuredChange() {
        var that = this;

        $.ajax({
            url: '/event/change-featured',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                featured: $('#featured-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }

    privateChange() {
        var that = this;

        $.ajax({
            url: '/event/change-public',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                private: $('#private-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }

    soldOutChange() {
        var that = this;

        $.ajax({
            url: '/event/change-sold-out',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                sold_out: $('#sold-out-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }
}

export { Event }
